// Shared Stimulus controllers used across the entire app.
// Lesson-specific controllers should go in lesson.js instead.
import { Application } from '@hotwired/stimulus';
import Clipboard from '@stimulus-components/clipboard';
import Dialog from '@stimulus-components/dialog';
import PasswordVisibility from '@stimulus-components/password-visibility';
import AdaptiveFilterController from '../controllers/adaptive_filter_controller';
import AnalyticsController from '../controllers/analytics_controller';
import DismissController from '../controllers/dismiss_controller';
import GifControlsController from '../controllers/gif_controls_controller';
import LabInstructionsController from '../controllers/lab_instructions_controller';
import LabViewerController from '../controllers/lab_viewer_controller';
import ProfileMenuDropdownController from '../controllers/profile_menu_dropdown_controller';
import ScrollIntoViewController from '../controllers/scroll_into_view_controller';
import SlidesController from '../controllers/slides_controller';
import ToggleDropdownsController from '../controllers/toggle_dropdowns_controller';
import TooltipsController from '../controllers/tooltips_controller';
import '@hotwired/turbo-rails';

window.Stimulus = Application.start();
// Register shared controllers (lesson-specific controllers are registered in lesson.js)
Stimulus.register('analytics', AnalyticsController);
Stimulus.register('toggle-dropdowns', ToggleDropdownsController);
Stimulus.register('password-visibility', PasswordVisibility);
Stimulus.register('profile-menu-dropdown', ProfileMenuDropdownController);
Stimulus.register('clipboard', Clipboard);
Stimulus.register('dialog', Dialog);
Stimulus.register('dismiss', DismissController);
Stimulus.register('gif-controls', GifControlsController);
Stimulus.register('lab-instructions', LabInstructionsController);
Stimulus.register('lab-viewer', LabViewerController);
Stimulus.register('adaptive-filter', AdaptiveFilterController);
Stimulus.register('scroll-into-view', ScrollIntoViewController);
Stimulus.register('slides', SlidesController);
Stimulus.register('tooltips', TooltipsController);
